/**
 * Single registry of tenant feature flags. Keys must match LaunchDarkly and backend OpenFeature
 * flag names exactly (`tg_` prefix, snake_case). Defaults must stay in sync with backend fail-closed
 * values (DT-10350).
 */
export type TenantFlagKey = `tg_${Lowercase<string>}`;

export const flagDefaults: Partial<Record<TenantFlagKey, boolean>> = {};
